export const SETINVITECODE = 'SETINVITECODE'

export interface SetInviteCodeAction {
    type: typeof SETINVITECODE;
    shareCode: string;
}

export type ShareActionTypes = SetInviteCodeAction;